/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
/* eslint-disable no-use-before-define */
export {};
//# sourceMappingURL=interface.js.map